import { Spinner } from './Spinner';
import { LoaderContainerStyled } from "./styled/LoaderStyled";

export const Loader = ({show}) =>
    show ? (
        <LoaderContainerStyled>
            <Spinner/>
        </LoaderContainerStyled>
    ) : null;
